import { useEffect, useState } from 'react';
import { OlderSnapshotAssignmentNotice } from './OlderSnapshotAssignmentNotice';
import { ReflectToRulesSwitch } from './ReflectToRulesSwitch';

type DeleteAssignedLabelConfirmContentProps = {
  defaultReflectToRules: boolean;
  onReflectToRulesChange: (reflectToRules: boolean) => void;
  showOlderSnapshotNotice?: boolean;
  showReflectToRules?: boolean;
};

export const DeleteAssignedLabelConfirmContent = ({
  defaultReflectToRules,
  onReflectToRulesChange,
  showOlderSnapshotNotice = false,
  showReflectToRules = true,
}: DeleteAssignedLabelConfirmContentProps) => {
  const [reflectToRules, setReflectToRules] = useState(defaultReflectToRules);

  useEffect(() => {
    onReflectToRulesChange(reflectToRules);
  }, [onReflectToRulesChange, reflectToRules]);

  return (
    <div className='flex flex-col gap-sm'>
      {showOlderSnapshotNotice ? <OlderSnapshotAssignmentNotice /> : null}
      {showReflectToRules ? (
        <ReflectToRulesSwitch
          checked={reflectToRules}
          onChange={setReflectToRules}
        />
      ) : null}
    </div>
  );
};
